module.exports = __webpack_public_path__ + "static/media/bigImg.6202f797.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/bigImg.jpg
// module id = 343
// module chunks = 2